import { defineQuery } from 'groq';

export const loyaltyHomepageConfigQuery = defineQuery(`
  *[_type == "loyaltyHomepageConfig" && _id == "loyaltyHomepageConfig"]{
    _updatedAt,
    unauthenticatedUsers {
      layout ->,
      widgets[]->
    }
  }[0]
`);
